"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _List = require("../../../List/List");

var CustomWrapper = (0, _styledComponents["default"])(_List.Wrapper).withConfig({
  displayName: "sc-02_Legends__CustomWrapper",
  componentId: "sc-bvfn4m-0"
})(["overflow-y:auto;overflow-x:hidden;"]);
var CustomItem = (0, _styledComponents["default"])(_List.Item).withConfig({
  displayName: "sc-02_Legends__CustomItem",
  componentId: "sc-bvfn4m-1"
})(["width:100%;line-height:", ";font-size:", ";&::before{background-color:", " !important;height:18px !important;width:18px !important;margin-top:0px !important;margin-right:10px !important;margin-left:5px !important;border:2px solid white !important;}"], function (_ref) {
  var device = _ref.device;
  return device === "MOBILE" ? "20px" : "22px";
}, function (_ref2) {
  var device = _ref2.device;
  return device === "MOBILE" ? "12px" : "14px";
}, function (_ref3) {
  var fillStyle = _ref3.fillStyle;
  return fillStyle;
}); // Contains the chart labels.

var Legends = function Legends(_ref4) {
  var legends = _ref4.legends,
      device = _ref4.device,
      chartHeight = _ref4.chartHeight,
      colorScale = _ref4.colorScale;
  var turn = 0;
  var colorIndex = 0;
  var scaleLength = colorScale.length;
  return /*#__PURE__*/_react["default"].createElement(CustomWrapper, {
    m: "0px",
    spacing: "10px",
    width: "50%",
    pl: ["0px", "5px", "10px"],
    height: ["100%", chartHeight, chartHeight]
  }, legends == null ? void 0 : legends.map(function (_ref5) {
    var text = _ref5.text,
        index = _ref5.index;
    var currentTurn = Math.floor(index / scaleLength);
    if (index !== 0 && turn === currentTurn) colorIndex += 1;

    if (turn !== currentTurn) {
      turn += 1;
      colorIndex = 0;
    }

    return /*#__PURE__*/_react["default"].createElement(CustomItem, {
      key: index,
      device: device,
      fillStyle: colorScale[colorIndex]
    }, text);
  }));
};

var _default = Legends;
exports["default"] = _default;